const Loading = () =>{

    return(
      <div id="Loading">
         <div className="d-flex align-items-center">
           <div className="spinner-border ml-auto" role="status" aria-hidden="true"></div>
         </div>
      </div>
    )
}

export default Loading;